<footer class="main-footer container">
    <p class="copyright">&copy; SPORTLOGiQ</p>
</footer>